module.exports = __webpack_public_path__ + "img/child.cbdea7af.svg";